import { useConfigQuery } from "@hooks";

import * as Apis from "../api";

const usePeiQuery = (() => {
  return useConfigQuery({ apis: Apis });
})();

export default usePeiQuery;
